import React, { memo } from 'react';
import MessageFooter from '../MessageFooter/MessageFooter';
import { Box, Button, ChatMessage, Text } from 'pcln-design-system';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
import { parseISO } from 'date-fns/parseISO';
import { isFuture } from 'date-fns/isFuture';
import { isToday } from 'date-fns/isToday';
import { ListOfDifferentTrips } from './ListOfTrips';
import { MyTripDataProvider } from './myTripDataContext';
const Trips = ({
  trips = [],
  deepLinkPrompt,
  tripHeaderMsg = "I'm happy to help! Below are your trips, please select the one you need help with:",
  hasMoreTrips = false,
  displayInRealtimeVoice = false,
  submitChatMessageInMarkerComponent
}) => {
  const currentTrips = [];
  const upcomingTrips = [];
  const pastTrips = [];
  const canceledTrips = [];
  trips.map(trip => {
    const checkStartDate = (trip === null || trip === void 0 ? void 0 : trip.travelStartDate) || new Date().toISOString();
    const checkEndDate = (trip === null || trip === void 0 ? void 0 : trip.travelEndDate) || new Date().toISOString();
    const travelStart = parseISO(checkStartDate);
    const travelEnd = parseISO(checkEndDate);
    // Current trips aren't cancelled, and they either start today or started in the past and end in the future.
    const isCurrentTrip = !trip.isCanceled && (isToday(travelStart) || !isFuture(travelStart) && isFuture(travelEnd));
    const isUpcomingTrip = !trip.isCanceled && !isToday(travelStart) && isFuture(travelStart);
    const isPastTrip = !trip.isCanceled && !isToday(travelStart) && !isFuture(travelStart) && !isFuture(travelEnd);
    if (isCurrentTrip) {
      currentTrips.push(trip);
    } else if (isUpcomingTrip) {
      upcomingTrips.push(trip);
    } else if (isPastTrip) {
      pastTrips.push(trip);
    } else if (trip.isCanceled) {
      canceledTrips.push(trip);
    }
  });
  if (displayInRealtimeVoice) {
    return React.createElement(MyTripDataProvider, {
      currentTrips: currentTrips,
      upcomingTrips: upcomingTrips,
      pastTrips: pastTrips,
      canceledTrips: canceledTrips,
      deepLinkPrompt: deepLinkPrompt
    }, React.createElement(ListOfDifferentTrips, null));
  }
  return (trips === null || trips === void 0 ? void 0 : trips.length) && !displayInRealtimeVoice ? React.createElement(React.Fragment, null, React.createElement(Box, {
    mb: 3
  }, React.createElement(ChatMessage, {
    ml: '',
    mb: '8px',
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: React.createElement(React.Fragment, null, React.createElement(Text, {
      mb: 2
    }, tripHeaderMsg), React.createElement(MyTripDataProvider, {
      currentTrips: currentTrips,
      upcomingTrips: upcomingTrips,
      pastTrips: pastTrips,
      canceledTrips: canceledTrips,
      deepLinkPrompt: deepLinkPrompt,
      submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent
    }, React.createElement(ListOfDifferentTrips, null))),
    footer: React.createElement(MessageFooter, null)
  })), hasMoreTrips ? React.createElement(Box, {
    my: 3,
    ml: 3
  }, React.createElement(Button, {
    onClick: function () {
      window.open('/next-profile/trips');
    },
    variation: 'subtle'
  }, "View All Trips")) : null) : null;
};
export default memo(Trips);